import React, { createContext, useContext } from 'react';
import { useQuery } from 'react-apollo';
import isUndefined from 'lodash/isUndefined';

import { useAuthService } from '@/contexts/authService';
import { UserQueryPrivate } from '../state/services/gql/user';

const ProfileContext = createContext();

export const ProfileProvider = ({ children }) => {
  const authService = useAuthService();
  const userId = authService.getUserCookie();
  const result = useQuery(UserQueryPrivate, {
    variables: { id: userId },
    errorPolicy: 'all',
    skip: !userId,
  });

  return (
    <ProfileContext.Provider value={result}>{children}</ProfileContext.Provider>
  );
};
export const useProfile = () => {
  const context = useContext(ProfileContext);

  if (isUndefined(context)) {
    throw new Error('useProfile must be used within a ProfileContext');
  }

  return context;
};
